import { useSelector } from "react-redux";

export const User = () => {
  const user = useSelector((state) => state.user);
  return user.username;
};
